/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Aggregatore di N booleans per-componente verso un intero
 */
export enum Aggregatore {

    EXISTS = 'EXISTS',

    ALL = 'ALL',

    COUNT = 'COUNT',

    COUNT_GTE = 'COUNT_GTE'
}

